const getEnvVars = () => {
  let env = {
    APP_API_URL: "",
    API_V2: process.env.API_V2,
    HASURA_GQL: process.env.HASURA_GQL,
    KEYCLOAK: process.env.KEYCLOAK,
    JASPER_SERVER: process.env.JASPER_SERVER,
    GRAFANA: process.env.GRAFANA,
    NEXTCLOUD: process.env.NEXTCLOUD,
    APP_REST_REF: process.env.APP_REST_REF
  };

  try {
    // @ts-ignore
    if (typeof ENV !== "undefined") {
      env = { ...env, ...ENV };
    }
  } catch (e) {
    console.error(e);
  }
  return { env };
};

export { getEnvVars };
